module.exports = __webpack_public_path__ + "media/images/icons/filled/alert-79911b30ffe46960b302bd7448095c6b.svg";